<template>
  <div>

    <div class="front-desk__background" v-bind:style="{ backgroundImage: 'url(' + frontDesk.backgroundImageURL + ')' }">
      <div class="front-desk__name">{{frontDesk.establishmentName}}</div>
      <div class="front-desk__welcome-message">{{frontDesk.title}}</div>
      <ul class="front-desk__cta">
        <li v-on:click="requestPINIfSet"><button class="btn btn-primary">{{frontDesk.cta}}</button></li>
<!--        <li v-for="(link, index) in frontDesk.links" v-bind:key="index"><button class="btn btn-primary">{{link.linkText}}</button></li>-->
      </ul>
    </div>

    <ListForms v-if="showForms" v-bind:frontDeskURL="frontDeskURL" v-bind:frontDesk="frontDesk"></ListForms>
    <PINDialog v-if="showPINDialog" v-bind:establishmentReference="frontDesk.establishmentReference" v-bind:frontDeskURL="frontDeskURL" v-bind:callbackName="'pinEntered'" v-on:pinEntered="showListOfForms"></PINDialog>

  </div>
</template>

<script>
import ListForms from '../components/front-desk/ListForms.vue'
import PINDialog from '../components/front-desk/PINDialog.vue'

export default {
  name: 'FrontDesk',
  components: { ListForms, PINDialog },
  props: {
    frontDeskURL: String
  },
  data: function () {
    return {
      frontDesk: {
        backgroundImageURL: ''
      },
      showPINDialog: false,
      showForms: false
    }
  },
  methods: {
    requestPINIfSet: function () {
      if (this.frontDesk.secured) {
        this.showPINDialog = true
      } else {
        this.showListOfForms()
      }
    },
    pinEntered: function (success) {
      this.showPINDialog = false
      if (success) {
        this.showListOfForms()
      }
    },
    showListOfForms: function () {
      this.showForms = true
    },
    fetchFrontDeskData: function () {
      this.$http.get('/guest/v1/front-desk/' + this.frontDeskURL).then(response => {
        this.frontDesk = response.data
      }).catch(error => {
        console.log(error)
        if (error.response) {
          // client received an error response (5xx, 4xx)
          // this.errorMessage = 'Sorry, but we couldn\'t load your form properly. Please try again'
        } else {
          // this.errorMessage = 'Sorry, we\'re having problems preparing your form. Please try again'
        }
      })
    }
  },
  mounted () {
    if (this.frontDeskURL) {
      this.fetchFrontDeskData()
    }
    this.$root.$on('pinEntered', this.pinEntered)
    this.$root.$on('list-forms-closed', () => { this.showForms = false })
  },
  destroyed () {
    this.$root.$off('pinEntered', this.pinEntered)
    this.$root.$off('list-forms-closed')
  }
}
</script>

<style scoped>

  .front-desk__background {
    height: 100vh;
    background: no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: hidden;
  }

  .front-desk__background::after {
     content: "";
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100%;
     background-color: rgba(0,0,0,0.6);
     z-index: 1;
   }

  .front-desk__background > * {
    z-index: 100;
  }

  .front-desk__welcome-message {
    color: #fff;
    text-align: center;
    font-size: 60px;
    font-weight: bold;
    margin-top: 15%;
    position: relative;
  }

  .front-desk__name {
    color: #fff;
    text-align: left;
    font-size: 30px;
    font-weight: bold;
    margin: 20px 0 0 40px;
    position: relative;
  }

  .front-desk__cta {
    position: relative;
    list-style: none;
    margin-top: 40px;
    padding: 0;
    text-align: center;
    display: table;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }

  .front-desk__cta li {
    display: table-cell;
    width: 50%;
    margin: 10px;
    padding: 5px 50px;
  }

  .front-desk__cta button {
    width: 100%;
    font-size: 30px;
    font-weight: bold;
    padding: 10px 30px;
  }
</style>
